import { createStyles } from '@material-ui/core/styles';

export default () => createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '50px',
  },
  contentContainer: {
    marginTop: '50px',
  },
  mapWrapper: {
    height: '100%',
  },
  mapContainer: {
    width: '100%',
    height: '100%',
  },
  markerWrapper: {
    position: 'relative',
  },
  marker: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transform: 'translate(-50%, -100%)',
  },
  markerInner: {
    borderRadius: 6,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: 12,
    fontWeight: 500,
    minWidth: 90,
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  },
  markerActive: {
    opacity: 0.8,
  },
  markerLabel: {
    color: '#fff',
    padding: '5px 10px',
    textAlign: 'center',
  },
  markerStatus: {
    color: '#fff',
    padding: '3px 10px',
    textAlign: 'center' as const,
    fontSize: 10,
  },
  cluster: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 44,
    height: 44,
    borderRadius: '50%',
    background: '#DB5C0E',
    color: '#fff',
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(219,92,14,0.5)',
    transform: 'translate(-50%, -50%)',
    border: '2px solid #fff',
  },
  popup: {
    position: 'absolute',
    background: '#fff',
    borderRadius: 10,
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    padding: '16px',
    width: 260,
    transform: 'translate(-50%, calc(-100% - 50px))',
    zIndex: 100,
    fontSize: 13,
    color: '#1a1a1a',
  },
  popupCloseBtn: {
    position: 'absolute',
    top: 10,
    right: 10,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 16,
    color: '#666',
    lineHeight: 1,
  },
  popupAddress: {
    fontWeight: 600,
    fontSize: 15,
    marginBottom: 8,
  },
  popupGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '6px 12px',
    color: '#444',
  },
  popupLabel: {
    fontSize: 11,
    color: '#999',
  },
  popupValue: {
    fontWeight: 500,
  },
});
